"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushMessageScope = exports.PushMessageType = void 0;
var PushMessageType;
(function (PushMessageType) {
    PushMessageType["PUSH_MSG_NOTIFICATION"] = "notification";
    PushMessageType["PUSH_MSG_TOKEN_REFRESH"] = "token.refresh";
    PushMessageType["PUSH_MSG_SERVER_MESSAGE"] = "server.message";
    PushMessageType["PUSH_MSG_LISTING_UPDATED"] = "listing.updated";
    PushMessageType["PUSH_MSG_RFQ_UPDATED"] = "rfq.updated";
    PushMessageType["PUSH_MSG_THREAD_UPDATED"] = "thread.updated";
    PushMessageType["PUSH_MSG_CHAT_UPDATED"] = "chat.updated";
    PushMessageType["PUSH_MSG_CHANGE_UPDATED"] = "change.updated";
    PushMessageType["ORDER_DOCUMENT_UPLOADED"] = "document.uploaded";
})(PushMessageType = exports.PushMessageType || (exports.PushMessageType = {}));
var PushMessageScope;
(function (PushMessageScope) {
    PushMessageScope["GLOBAL"] = "GLOBAL";
    PushMessageScope["COMPANY"] = "COMPANY";
    PushMessageScope["ADMIN"] = "ADMIN";
})(PushMessageScope = exports.PushMessageScope || (exports.PushMessageScope = {}));
